import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { kind: String }

  connect() {
    if (document.documentElement.hasAttribute("data-turbo-native-app")) return
    this.update()
    if (this.kindValue === "products") {
      this.observer = new MutationObserver(() => this.schedule())
      this.observer.observe(this.element, { childList: true })
    }
  }

  disconnect() {
    this.observer?.disconnect()
    clearTimeout(this.timeout)
  }

  schedule() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.update(), 250)
  }

  update() {
    let rows
    if (this.kindValue === "products") {
      rows = this.element.querySelectorAll(":scope > [data-product-card-id]")
    } else if (this.kindValue === "ingredients") {
      rows = this.element.querySelectorAll(".ingredient-table-row")
    } else {
      rows = Array.from(this.element.children).filter(row => !this.isHint(row))
    }
    rows.forEach((row, index) => {
      if (this.kindValue === "products") {
        if ((index + 1) % 4 === 0) this.insert(row, "content_mobile_hint")
      } else if (this.kindValue === "ingredients") {
        if ((index - 1) % 2 === 0) this.insert(row, "content_mobile_hint")
        if ((index - 1) % 3 === 0) this.insert(row, "content_desktop_hint")
      } else {
        this.insert(row, "content_mobile_hint")
        if ((index - 1) % 2 === 0) this.insert(row, "content_desktop_hint")
      }
    })
  }

  insert(row, className) {
    let sibling = row.nextElementSibling
    while (sibling && this.isHint(sibling)) {
      if (sibling.classList.contains(className)) return
      sibling = sibling.nextElementSibling
    }
    const hint = document.createElement("div")
    hint.classList.add(className)
    row.insertAdjacentElement("afterend", hint)
  }

  isHint(element) {
    return element.classList.contains("content_mobile_hint") || element.classList.contains("content_desktop_hint")
  }
}
